// extracted by mini-css-extract-plugin
export default {"modalContainer":"AddLessonOrMeeting_modalContainer__w-B6J","wrapper":"AddLessonOrMeeting_wrapper__XaIwI","button":"AddLessonOrMeeting_button__VPGMm"};